import { render, staticRenderFns } from "./FunnelWeddingSitecore.vue?vue&type=template&id=427a27f7"
import script from "./FunnelWeddingSitecore.vue?vue&type=script&lang=js"
export * from "./FunnelWeddingSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports